module.exports = __webpack_public_path__ + "img/roll.74fda395.png";